<template>
    <div>
        <a-table
                rowKey="id"
                bordered
                :dataSource="dataList"
                :columns="columns"
                :pagination="false"
        >
            <span slot="operation" slot-scope="text, record">
                <a @click="showReport(record.uscc,record.btzqymci)">查看档案</a>
            </span>
            <!--序号翻页自增-->
            <span slot="num" slot-scope="text, record, index">
                {{(pagination.current-1)*pagination.pageSize+parseInt(index)+1}}
            </span>
        </a-table>

        <div style="float: right">
            <a-pagination
                    size="middle"
                    style="margin-top:20px"
                    v-model="pagination.current"
                    :pageSize="pagination.pageSize"
                    @change="pageNumberChange"
                    @showSizeChange="sizeChange"
                    :pageSizeOptions="sizeList"
                    :total="pagination.total"
                    :show-total="(total, range) => `共有 ${total} 条数据`"
            >

            </a-pagination>
        </div>

        <div>
            <a-modal v-model="reportVisible" footer="" width="1300px" @cancel="cleanData">
                <a-spin tip="Loading..." :spinning="reportSpinning">
                    <a-tabs defaultActiveKey="1" style="margin-top: 20px">
                        <a-tab-pane tab="基本信息" key="1">
                            <a-descriptions bordered :column="1">

                                <a-descriptions-item :label="basic.head[index]" v-for="(key,index) in basic.body">
                                    {{key}}
                                </a-descriptions-item>
                            </a-descriptions>
                        </a-tab-pane>
                    </a-tabs>
                    <!--bottom-->
                    <a-tabs defaultActiveKey="2" style="margin-top: 20px">
                        <a-tab-pane :tab="item.title" :key="index" forceRender v-for="(item,index) in list">
                            <!-- 底部所有tab -->
                            <div
                                    v-if="item.title !== '金融信用信息' && item.body.length == 0">
                                <template>
                                    <a-empty description="查询期内无相关记录"/>
                                </template>
                            </div>
                            <div v-if="item.title == '金融信用信息' && item.body.length == 0">
                                <template>
                                    <a-empty description="查询期内无相关记录"/>
                                </template>
                            </div>
                            <a-descriptions style="margin-bottom: 20px"
                                            v-if="item.title !== '其他信息' && item.title !== '金融信用信息'"
                                            bordered :column="1" v-for="(key,index) in item.body">
                                <a-descriptions-item :label="val" v-for="(val,indexHead) in item.head">
                                    {{key[indexHead]}}
                                </a-descriptions-item>
                            </a-descriptions>
                            <!-- 其他信息 -->
                            <div v-if="item.title == '其他信息'" v-for="(key,index) in item.body">
                                <p class="mes_nr" style="border:none;font-weight: bold;font-size: 15px;">
                                    {{key.title}}</p>
                                <p v-if="key.body.length == 0" class="mes_nr"
                                   style="border: none;color: red;width: 100%;">
                                    查询期内无相关记录
                                </p>
                                <a-descriptions bordered :column="1" v-for="(bo,indexBody) in key.body"
                                                style="margin-bottom: 20px">
                                    <a-descriptions-item :label="val" v-for="(val,indexHead) in key.head">
                                        {{bo[indexHead]}}
                                    </a-descriptions-item>
                                </a-descriptions>
                            </div>
                            <!--纳税信息-->
                            <div v-if="item.title == '金融信用信息'" v-for="(val,valIndex) in item.body">
                                <p style="width: 100%;text-align: center;border: none;font-weight: bold;font-size: 15px;"
                                   class="mes_nr">{{val.title}}</p>
                                <p v-if="val.body.length == 0" class="mes_nr"
                                   style="border: none;color: red;width: 100%;">
                                    查询期内无相关记录
                                </p>
                                <p v-else-if="val.body[0] == '查询失败'" class="mes_nr"
                                   style="border: none;color: red;width: 100%;">
                                    {{val.body[0]}}
                                </p>
                                <a-descriptions v-else bordered :column="1" v-for="(key,indexBody) in val.body"
                                                style="margin-bottom: 20px">
                                    <a-descriptions-item :label="head" v-for="(head,headIndex) in val.head">
                                        {{key[headIndex]}}
                                    </a-descriptions-item>
                                </a-descriptions>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </a-spin>

            </a-modal>
        </div>
    </div>
</template>

<script>
    import {getAffiliatedCompanyList, myReport} from "@/api/http"

    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            key: "index",
            scopedSlots: {customRender: 'num'},
            // customRender: (text, record, index) => `${index + 1}`
        },
        {
            title: "企业名称",
            dataIndex: "btzqymci",
            key: "btzqymci"
        },
        {
            title: "统一社会信用代码",
            dataIndex: "uscc",
            key: "uscc"
        },
        {
            title: "关联关系",
            dataIndex: "relation",
            key: "relation"
        },
        {
            title: "操作",
            dataIndex: "operation",
            scopedSlots: {customRender: "operation"}
        },
    ]
    export default {
        name: "AffiliatedCompany",
        data() {
            return {
                columns,
                commpanyList: [],
                pagination: {
                    pageSize: 10, //当前实际一页显示多少条
                    current: 1,//当前是哪一页
                    total: 0 //总条数,在获取后台数据时将数组的length赋值给total
                },
                uscc: "",
                reportVisible: false,
                reportSpinning: false,
                list: [],
                dataList: [],
                basic: {},
                taxList: {},
                sizeList: ['2', '4', '5'], //一页能显示多少条
            }
        },
        created() {
            this.initList();
        },
        methods: {
            //分页页数的改变
            pageNumberChange(current, size) {
                this.pagination.current = current;
                this.pagination.pageSize = size;
                this.dataList = this.getShowSource();
            },
            //  分页显示条数的变化
            sizeChange(current, size) {
                this.pagination.current = current;
                this.pagination.pageSize = size;
                this.dataList = this.getShowSource();
            },
            getShowSource() {
                let keyValue = 0;
                let data = this.commpanyList;
                for (var i = 0; i < data.length; i++) {
                    keyValue = keyValue + 1;
                    let key = {key: keyValue};
                    data[i] = Object.assign(data[i], key);
                }
                const start = this.pagination.pageSize * this.pagination.current - this.pagination.pageSize;
                const end = this.pagination.pageSize * this.pagination.current;
                return data.slice(start, end);
            },
            initList() {
                getAffiliatedCompanyList().then(resp => {
                    if (resp.data.success == "TRUE") {
                        this.commpanyList = resp.data.data.list;
                        this.dataList = this.getShowSource();
                        this.pagination.total = resp.data.data.list.length;
                    }
                }).catch(() => this.$message.error("服务器异常，请稍后再试！"))
            },
            showReport(uscc, qyName) {
                this.uscc = uscc;
                this.reportVisible = true;
                this.reportSpinning = true;
                this.getCompanyDetail(uscc, qyName);
            },
            cleanData() {
                this.downSpinning = false;
                this.reportSpinning = false;
                this.list = [];
                this.basic = {};
                this.taxList = {};
            },

            async getCompanyDetail(uscc, qyName) {
                await myReport(uscc, qyName)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            if (res.data.success === 'TRUE') {
                                if (JSON.stringify(res.data.data.result) != "{}") {
                                    // console.log(res.data.data.result);
                                    this.basic = res.data.data.result.result.basic;
                                    this.list = res.data.data.result.result.list;
                                    this.reportSpinning = false;
                                } else {
                                    this.reportSpinning = false;
                                    this.reportVisible = false;
                                    this.basic = {};
                                    this.tyshxydm = "123";
                                    this.list = [];
                                }
                            } else {
                                this.reportSpinning = false;
                                this.reportVisible = false;
                                this.$message.error("无法获取当前登录企业!");
                            }
                        });
                    })
                    .catch(() => {
                        this.reportSpinning = false;
                        this.reportVisible = false;
                        this.$message.error("服务器出错！请稍后再试!");
                    });
            },
        }

    }
</script>

<style scoped>

    .mes_nr {
        line-height: 35px;
        border-left: solid 1px #d7d7d7;
        padding-left: 5px;
        text-align: center;
    }
</style>